import React, { useEffect } from "react";
import "./Dashboard.scss";
import { ReactComponent as TotalProject } from "../../Assets/Images/Group 1171275921.svg";
import { ReactComponent as TotalTower } from "../../Assets/Images/Group 1171275923.svg";
import { ReactComponent as TotalRegistration } from "../../Assets/Images/Group 1171275949.svg";
import { ReactComponent as Totalhandover } from "../../Assets/Images/Icon.svg";
import { SvgIcon } from "@mui/material";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import DatePickers from "../../Components/DatePicker/DatePicker";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { dashboardCard } from "../../Redux/Slicers/Dashboard/DashboardCardSlice";

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const { data: dashboardCardData } = useAppSelector(
    (state) => state.DashboardCard
  );
console.log(dashboardCardData);

useEffect(() => {
  dispatch(dashboardCard());
}, []);
return (
  <div className="dashboard_container">
    <div className="dashboard_header_container">
      <div className="dashboard_headings_container">
        <p className="dashboard_heading">Dashboard</p>
        <p className="dashboard_sub_heading">Project Overview</p>
      </div>
      <div className="dashboard_header_cards_container">
        {dashboardCardData?.response?.data?.role != 'owner' ? (
          <>
            <div
              className="dashboard_card"
              style={{ backgroundColor: '#FFE2E5' }}>
              <SvgIcon
                className="dashboard_icon"
                component={TotalProject}
                inheritViewBox
              />

              <div className="dashboard_content_container">
                <p className="content_title">Total Owner</p>
                <p className="content_value">
                  {dashboardCardData?.response?.data?.owner}
                </p>
              </div>
            </div>
            <div
              className="dashboard_card"
              style={{ backgroundColor: '#c33eb169' }}>
              <SvgIcon
                className="dashboard_icon"
                component={TotalRegistration}
                inheritViewBox
              />

              <div className="dashboard_content_container">
                <p className="content_title">Total User</p>
                <p className="content_value">
                  {dashboardCardData?.response?.data?.users}
                </p>
              </div>
            </div>
            <div
              className="dashboard_card"
              style={{ backgroundColor: '#FFF4DE' }}>
              <SvgIcon
                className="dashboard_icon"
                component={TotalTower}
                inheritViewBox
              />

              <div className="dashboard_content_container">
                <p className="content_title">Total Vehicle</p>
                <p className="content_value">
                  {dashboardCardData?.response?.data?.vehicles}
                </p>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
        <div
          className="dashboard_card"
          style={{ backgroundColor: '#DCFCE7' }}>
          <SvgIcon
            className="dashboard_icon"
            component={Totalhandover}
            inheritViewBox
          />

          <div className="dashboard_content_container">
            <p className="content_title">Total Location</p>
            <p className="content_value">
              {dashboardCardData?.response?.data?.location}
            </p>
          </div>
        </div>
        <div
          className="dashboard_card"
          style={{ backgroundColor: '#1cc0b775' }}>
          <SvgIcon
            className="dashboard_icon"
            component={TotalRegistration}
            inheritViewBox
          />

          <div className="dashboard_content_container">
            <p className="content_title">Total Slot</p>
            <p className="content_value">
              {dashboardCardData?.response?.data?.slot}
            </p>
          </div>
        </div>

        <div
          className="dashboard_card"
          style={{ backgroundColor: '#DCE1FC' }}>
          <SvgIcon
            className="dashboard_icon"
            component={TotalRegistration}
            inheritViewBox
          />

          <div className="dashboard_content_container">
            <p className="content_title">Total Activity</p>
            <p className="content_value">
              {dashboardCardData?.response?.data?.activity}
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* <div className="dashboard_datagrid_container">
        <Table
          rows={[]}
          columns={[]}>
          <CustomToolbar className="dashboard_custom_toolbar">
            <DatePickers onChange={(val) => console.log(val)} />
          </CustomToolbar>
        </Table>
      </div> */}
  </div>
);
};

export default Dashboard;
